module.exports = __webpack_public_path__ + "static/media/button-next.8a4be8bb.svg";